import React from 'react';
import { useSearchParams } from 'react-router-dom';
import UserDashboard from './UserDashboard';
import OverviewDashboard from './OverviewDashboard';
import DashboardLayout from '../components/Layout/DashboardLayout';

/**
 * /dashboard now shows the new Overview by default.
 * The previous dashboard is still reachable at /dashboard?view=classic
 */
const DashboardSwitch = () => {
  const [params] = useSearchParams();
  if (params.get('view') === 'classic') {
    return <UserDashboard />;
  }
  return (
    <DashboardLayout>
      <OverviewDashboard />
    </DashboardLayout>
  );
};

export default DashboardSwitch;
